import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

const clearOther = (otherField) => {
  clearInputField(otherField);

  otherField.disabled = true;
  otherField.classList.add('focus-visible');
}

$(document).ready(() => {
  const $form = $('form#natural-profile-form');
  const step  = getQueryStringParameter('id');

  if ($form.length === 0 || (step !== null && step !== '' && step !== 'profession' && !window.location.pathname.endsWith('new'))) {
    return;
  }

  const $professionFields = $('#professionFields input[type=radio]', $form);
  const otherField        = document.getElementById('users_profile_natural_profession_other');

  // On load clear "other" input if one radio is checked

  $professionFields.each((_, inputElement) => {
    if(inputElement.checked) {
      clearInputField(otherField);
    }
  });

  // On load apply outline on "other" input if it's not empty

  if(otherField.value.length > 0) {
    otherField.classList.add('focus-visible');
  };

  // Clear radio values

  otherField.addEventListener('click', () => {
    $professionFields.each((_, inputElement) => {
      if(inputElement.checked) {
        inputElement.checked = false;
      }
    });
  });

  // Clear "other" input then submit the form

  $professionFields.on('click', (e) => {
    if(e.target.id != 'users_profile_natural_profession_other') {
      clearOther(otherField);
      $form.submit();
    };
  });

  // On submit button click, if one radio is checked clear "other" input then
  // submit the form else clear radio values then submit the form

  $('#submitStep').on('click', (e) => {
    e.preventDefault();

    $professionFields.each((_, inputElement) => {
      if(inputElement.checked) {
        clearOther(otherField);
      } else {
        inputElement.checked = false;
      }
    });

    $form.submit();
  });
})
